"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationPresetDTO = void 0;
class NotificationPresetDTO {
}
exports.NotificationPresetDTO = NotificationPresetDTO;
//# sourceMappingURL=notification-preset.js.map